// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               unknown
// source: types/query_eip712.proto

import { BinaryReader, BinaryWriter } from "../../binary";
import {
  base64FromBytes,
  bytesFromBase64,
  DeepPartial,
  Exact,
  isSet,
} from "../../helpers";

/* eslint-disable */

export const protobufPackage = "types";

export interface QueryEip712TypedDataRequest {
  signBytes: Uint8Array;
}

export interface QueryEip712TypedDataResponse {
  typedData: string;
}

function createBaseQueryEip712TypedDataRequest(): QueryEip712TypedDataRequest {
  return { signBytes: new Uint8Array(0) };
}

export const QueryEip712TypedDataRequest = {
  encode(
    message: QueryEip712TypedDataRequest,
    writer: BinaryWriter = BinaryWriter.create()
  ): BinaryWriter {
    if (message.signBytes.length !== 0) {
      writer.uint32(10).bytes(message.signBytes);
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number
  ): QueryEip712TypedDataRequest {
    const reader =
      input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryEip712TypedDataRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.signBytes = reader.bytes();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QueryEip712TypedDataRequest {
    return {
      signBytes: isSet(object.signBytes)
        ? bytesFromBase64(object.signBytes)
        : new Uint8Array(0),
    };
  },

  toJSON(message: QueryEip712TypedDataRequest): unknown {
    const obj: any = {};
    if (message.signBytes.length !== 0) {
      obj.signBytes = base64FromBytes(message.signBytes);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QueryEip712TypedDataRequest>, I>>(
    base?: I
  ): QueryEip712TypedDataRequest {
    return QueryEip712TypedDataRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QueryEip712TypedDataRequest>, I>>(
    object: I
  ): QueryEip712TypedDataRequest {
    const message = createBaseQueryEip712TypedDataRequest();
    message.signBytes = object.signBytes ?? new Uint8Array(0);
    return message;
  },
};

function createBaseQueryEip712TypedDataResponse(): QueryEip712TypedDataResponse {
  return { typedData: "" };
}

export const QueryEip712TypedDataResponse = {
  encode(
    message: QueryEip712TypedDataResponse,
    writer: BinaryWriter = BinaryWriter.create()
  ): BinaryWriter {
    if (message.typedData !== "") {
      writer.uint32(10).string(message.typedData);
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number
  ): QueryEip712TypedDataResponse {
    const reader =
      input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryEip712TypedDataResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.typedData = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QueryEip712TypedDataResponse {
    return {
      typedData: isSet(object.typedData)
        ? globalThis.String(object.typedData)
        : "",
    };
  },

  toJSON(message: QueryEip712TypedDataResponse): unknown {
    const obj: any = {};
    if (message.typedData !== "") {
      obj.typedData = message.typedData;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QueryEip712TypedDataResponse>, I>>(
    base?: I
  ): QueryEip712TypedDataResponse {
    return QueryEip712TypedDataResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QueryEip712TypedDataResponse>, I>>(
    object: I
  ): QueryEip712TypedDataResponse {
    const message = createBaseQueryEip712TypedDataResponse();
    message.typedData = object.typedData ?? "";
    return message;
  },
};
